import { Dash } from "plotly.js";

// eslint-disable-next-line import/prefer-default-export
export class BaseDatasetDTO {
  identifier: string | null = null;

  title: string | null = null;

  unit: string | null = null;

  companyId: number | null = null;

  categoryId: number | null = null;

  categoryTitle: string | null = null;

  groupId: number | null = null;

  groupTitle: string | null = null;

  decimalPlaces: number | null = null;

  stringValueMapper: number | null = null;

  dataType: string | null = null;

  datasetClass: string | null = null;

  accessType: string | null = null;

  deviceId: number | null = null;

  tags: Array<string> = [];

  deleted?: boolean | null = null;

  currentLineConfig?: {
    color: string;
    width: number;
    dashType: Dash;
    range: {
      min: number | undefined;
      max: number | undefined;
    };
  };

  constructor(data: Partial<BaseDatasetDTO>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  toString(): string {
    return `${this.title} | ${this.unit}`;
  }
}
